var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShapeArrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 8,
    viewBox: "0 0 11 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.88682 6.862C5.79946 6.97215 5.68834 7.06113 5.56176 7.1223C5.43518 7.18346 5.29641 7.21523 5.15582 7.21523C5.01524 7.21523 4.87647 7.18346 4.74989 7.1223C4.62331 7.06113 4.51218 6.97215 4.42482 6.862L0.302824 2.058C0.105061 1.81811 -0.00123649 1.51587 0.0028238 1.205C-0.01818 0.908469 0.0786167 0.61562 0.272203 0.390019C0.46579 0.164418 0.740543 0.0242712 1.03682 0L9.27682 0C9.41615 0.0029294 9.55318 0.0359995 9.67851 0.096936C9.80383 0.157872 9.91448 0.24523 10.0028 0.353C10.1975 0.593513 10.3037 0.893568 10.3037 1.203C10.3037 1.51243 10.1975 1.81249 10.0028 2.053L5.88282 6.853L5.88682 6.862Z",
    fill: "#706F6F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShapeArrow);
export default __webpack_public_path__ + "static/media/ShapeArrow.7bc556e421d6a3ae2853468b97de2a01.svg";
export { ForwardRef as ReactComponent };